import { Link } from "react-router-dom";
import styles from "./FeaturesFinalCTA.module.css";

export default function FeaturesFinalCTA() {
  return (
    <section className={styles.section} id="cta">
      <div className={styles.container}>
        <div className={styles.card}>
          <h2 className={styles.h2}>Start hiring with confidence.</h2>
          <p className={styles.sub}>
            Join the companies already finding better candidates faster — backed
            by verified data, not gut feel.
          </p>
          <Link
            to="/login"
            className={`${styles.btn} ${styles.btnPrimary} ${styles.btnLg} md:mr-5`}
          >
            Get Started
          </Link>
          <div className={styles.meta}>
            <span>✓ One free trial match</span>
            <span className={styles.sep}>•</span>
            <span>✓ Verified Profiles only</span>
          </div>
        </div>
      </div>
    </section>
  );
}
